<template>
    <carousel v-if="properties" :autoPlay="false" :active="activeSlide" @slide="(num) => activeSlide=num" :class="cssClass" :bottomControls="true" controlsCssCls="mt-5">
        <template #default>
            <property-featured-carousel-card v-for="(property, index) in properties" :key="`properties-featured-carousel-${property.id}-${index}`" :property="property" :class="slideCssClass" :active="activeSlide==index" />
        </template>
        <template #footer>
            <carousel-indicators :active="activeSlide" @click="(num) => activeSlide=num" class="mt-5 mb-3">
                <carousel-indicator-dot v-for="(property, index) in properties" :key="`properties-featured-carousel-indicator-${index}`" color="secondary" activeColor="primary" :active="activeSlide == index" size="sm"/>
            </carousel-indicators>
        </template>
    </carousel>
    <div v-else class="p-5 text-center">
        <spinner/>
    </div>
</template>

<script type="text/javascript">

    import CommonComponents from '@/components/Common.vue';
    import PropertyFeaturedCarouselCard from '@/components/Content/Public/Properties/Cards/FeaturedCarousel.vue';

    import ApiConfig from '@/config/api.json';
    import { UseApiStore } from '@/store/Api.js';
    import { UseUIStore } from '@/store/UI.js';

    export default {
        components: {
            PropertyFeaturedCarouselCard,
            ...CommonComponents,
        },

        setup() {
            return {
                apiStore: UseApiStore(),
                uiStore: UseUIStore(),
            };
        },

        data() {
            return {
                activeSlide: 1,

                error: null,
                disposed: false,
                emptyResults: null,
                requestsTimer: null,
            };
        },

        created() {
            this.requestData();
        },

        beforeUnmount() {
            clearTimeout(this.requestsTimer);
            this.disposed = true;
        },
        
        props: {
            serviceLevel: {
                type: String,
                default: 'W',
            },
        },

        computed: {
            cssClass() {
                if (this.uiStore.isMobile) {
                    return 'peek vh-50';
                }
                else if (this.uiStore.isTablet) {
                    return 'peek vh-40';
                }
                return 'vh-60 quarter';
            },

            slideCssClass() {
                if ((this.uiStore.isMobile) || (this.uiStore.isTablet)) {
                    return 'peek mx-1';
                }
                return 'half mx-3';
            },

            requestUrl() {
                let url = 'properties/featured';
                let query = {};
                if (this.serviceLevel) {
                    query.serviceLevel = this.serviceLevel;
                }
                url += '?'+new URLSearchParams(query).toString();
                return url;
            },

            properties() {
                let response = this.apiStore.requests[this.requestUrl];
                
                if (!response) {
                    return null;
                }

                if ((response.valid) && (response.results) && (!response.results.error)) {
                    if (response.results.length) {
                        return response.results;
                    }
                    else {
                        this.setEmptyResults(true);
                        return null;
                    }
                }
                else {
                    let error = 'Could not complete request';
                    if ((response.results) && (response.results.error)) {
                        if (response.results.error.message) error = response.results.error.message;
                        else error = response.results.error;
                    }
                    this.setError(error);
                }
                
                return null;
            },
        },

        methods: {
            async requestData() {
                if (this.disposed) return;
                
                this.setError(null);
                this.setEmptyResults(null);
                
                clearTimeout(this.requestsTimer);

                await this.apiStore.get(this.requestUrl);

                this.requestsTimer = setTimeout(this.requestData, ApiConfig.dashboardLongCache * 1000);
            },

            setError(error) {
                this.error = error;
            },
            
            setEmptyResults(val) {
                this.emptyResults = val;
            },
        },
    };

</script>
